import { render, staticRenderFns } from "./EmailTemplatesTable.vue?vue&type=template&id=f78e1594"
import script from "./EmailTemplatesTable.vue?vue&type=script&lang=js"
export * from "./EmailTemplatesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports